import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { NotificationSettingsPage } from 'features/profileSettings'

export const Route = createFileRoute('/_authenticated/_layout/profile/notifications')({
  component: NotificationSettingsPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('My Notifications'),
      },
    ],
  }),
})
